// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorContainer_H6rsD {
  display: flex;
}

.highlight_ZSkGK {
  animation: shake_O6a5i 2s ease infinite;
}
@keyframes shake_O6a5i {
	0%, 100% {transform: translateX(0);}
	10%, 30%, 50%, 70%, 90% {transform: translateX(-10px);}
	20%, 40%, 60%, 80% {transform: translateX(10px);}
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/attribute/editor/AttributeGridError.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,uCAAiC;AACnC;AACA;CACC,UAAU,wBAAwB,CAAC;CACnC,yBAAyB,4BAA4B,CAAC;CACtD,oBAAoB,2BAA2B,CAAC;AACjD","sourcesContent":[".errorContainer {\n  display: flex;\n}\n\n.highlight {\n  animation: shake 2s ease infinite;\n}\n@keyframes shake {\n\t0%, 100% {transform: translateX(0);}\n\t10%, 30%, 50%, 70%, 90% {transform: translateX(-10px);}\n\t20%, 40%, 60%, 80% {transform: translateX(10px);}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `errorContainer_H6rsD`,
	"highlight": `highlight_ZSkGK`,
	"shake": `shake_O6a5i`
};
export default ___CSS_LOADER_EXPORT___;
